import { render } from "./TheAttentionBar.vue?vue&type=template&id=69856b5e&ts=true"
import script from "./TheAttentionBar.vue?vue&type=script&lang=ts"
export * from "./TheAttentionBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBar from 'quasar/src/components/bar/QBar.js';
import qInstall from "../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBar});
